import React from "react";
import "./error.css";
import { useTranslation } from "react-i18next";

const Error = () => {
  const { t } = useTranslation();

  return (
    <div className="error-wrapper">
      <div className="error-content">
        <h3>{t("errorMessages.errorTitle")}</h3>
        <p>{t("errorMessages.errorDescription")}</p>
      </div>
    </div>
  );
};

export default Error;
